export default __webpack_public_path__ + "static/media/Logo.072a38ec.png";